module.exports = __webpack_public_path__ + "img/激活额度 (4).2996f902.png";